import React from 'react';
import { defineMessages, useIntl } from 'react-intl-next';
import { Text } from '@atlaskit/primitives/compiled';
import SectionMessage from '@atlaskit/section-message';
export const ErrorMessage = () => {
  const {
    formatMessage
  } = useIntl();
  return /*#__PURE__*/React.createElement(SectionMessage, {
    appearance: "error"
  }, /*#__PURE__*/React.createElement(Text, {
    as: "p"
  }, formatMessage(messages.description)));
};
const messages = defineMessages({
  description: {
    id: 'proforma-form-system.src.ui.form-card-index.form-card.form-card-body.error.title',
    defaultMessage: 'We’re unable to load this form. Refresh this page and try again.',
    description: 'Error message shown when a form fails to load.'
  }
});